import { useCallback, useState } from 'react'

const STORAGE_KEY = 'aries.sidebar_collapsed'

function readStoredCollapsed(): boolean {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (raw === null) return true
    return raw === '1' || raw === 'true'
  } catch {
    return true
  }
}

/** Sidebar starts collapsed; preference is persisted in localStorage. */
export function useSidebarCollapsed() {
  const [collapsed, setCollapsedState] = useState(readStoredCollapsed)

  const setCollapsed = useCallback((next: boolean | ((prev: boolean) => boolean)) => {
    setCollapsedState((prev) => {
      const value = typeof next === 'function' ? next(prev) : next
      try {
        localStorage.setItem(STORAGE_KEY, value ? '1' : '0')
      } catch {
        /* ignore quota / private mode */
      }
      return value
    })
  }, [])

  const toggle = useCallback(() => {
    setCollapsed((prev) => !prev)
  }, [setCollapsed])

  return { collapsed, setCollapsed, toggle }
}
